<template>
  <div class="container-fluid d-flex flex-row justify-content-center mel-glass-panel mel-glass-panel-content my-3">
    <div>
      <div class="mel-divider d-flex align-items-center my-3">
        <p class="text-center fw-bold mx-3 mb-0 text-primary">{{ $t('global.tenants', userTenants.length) }}</p>
      </div>
      <ul class="nav nav-pills flex-column">
        <li>
          <a @click="select_tenant(0)" href="#" class="nav-link text-decoration-none"
            :class="{ 'active': selectedTenantId === 0 }">
            <font-awesome-layers class="fa-1x me-2">
              <font-awesome-icon :icon="['fas', 'building']" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t('global.any' )}}</span>
          </a>
        </li>
        <li v-for="tenant in userTenants" :key="tenant.id">
          <a @click="select_tenant(tenant.id)" href="#" class="nav-link text-decoration-none"
            :class="{ 'active': selectedTenantId === tenant.id }">
            <font-awesome-layers class="fa-1x me-2">
              <font-awesome-icon :icon="['fas', 'building']" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ tenant.name }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="align-self-center">
      <font-awesome-layers class="fa-5x me-2 text-melodi">
        <font-awesome-icon :icon="['fas', 'chevron-right']" />
      </font-awesome-layers>
    </div>
    <div>
      <div class="mel-divider mel-divider-success d-flex align-items-center my-3">
        <p class="text-center fw-bold mx-3 mb-0 text-primary">{{ $t('global.sites', tenantFilteredUserSites.length) }}</p>
      </div>
      <ul class="nav nav-pills flex-column">
        <li>
          <a @click="select_site(0)" href="#" class="nav-link text-decoration-none"
            :class="{ 'active': selectedSiteId === 0 }">
            <font-awesome-layers class="fa-1x me-2">
              <font-awesome-icon :icon="['fas', 'warehouse']" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ $t('global.any' )}}</span>
          </a>
        </li>
        <li v-for="site in tenantFilteredUserSites" :key="site.id">
          <a @click="select_site(site.id)" href="#" class="nav-link text-decoration-none"
            :class="{ 'active': selectedSiteId === site.id }">
            <font-awesome-layers class="fa-1x me-2">
              <font-awesome-icon :icon="['fas', 'warehouse']" />
            </font-awesome-layers>
            <span class="ms-1 text">{{ site.name }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';

import { useSessionStore } from '@/stores';

const sessionStore = useSessionStore();
const { userTenants, userSites, selectedTenantId, selectedSiteId } = storeToRefs(sessionStore);

const tenantFilteredUserSites = computed(() => {
  if (selectedTenantId.value === 0) return userSites.value;
  return userSites.value.filter((site) => site.tenant.id === selectedTenantId.value);
});

const select_tenant = async (id: number) => await sessionStore.selectTenant(id);
const select_site = async (id: number) => await sessionStore.selectSite(id);
</script>

<style scoped>
.mel-glass-panel-content {
  transition: all 0.4s ease 0s;
  max-width: calc(100% - 40px);
  padding: 1rem;
  position: relative;
}
</style>
